var _a, _b, _c;
import * as Sentry from '@sentry/browser';
Sentry.init({
    dsn: 'https://ff63bf0e530b4daf889768ea21412919@o1180012.ingest.sentry.io/6292467',
});
import App from './App.svelte';
import { urls } from "@docsndata/lang-util";
import { environmentId, operatorId, showAdmin, tenantId, thankYouPageUrl } from "./stores";
const queryParams = urls.getQueryParams(window.location.href);
const suppliedServiceId = queryParams.serviceId;
const suppliedInviteId = queryParams.inviteId;
const paymentRequest = queryParams.paymentRequest;
const suppliedTenantId = (_a = queryParams.tenantId) !== null && _a !== void 0 ? _a : "thesmartwashltd";
const suppliedEnvironmentId = (_b = queryParams.environmentId) !== null && _b !== void 0 ? _b : "live";
const thankYouUrl = (_c = queryParams.thankYouUrl) !== null && _c !== void 0 ? _c : null;
tenantId.set(suppliedTenantId);
operatorId.set(suppliedTenantId);
environmentId.set(suppliedEnvironmentId);
showAdmin.set(queryParams.admin === "true");
thankYouPageUrl.set(thankYouUrl);
const app = new App({
    target: document.body,
    props: {
        suppliedServiceId,
        suppliedInviteId,
        paymentRequest,
    }
});
export default app;
